import { render, staticRenderFns } from "./outplace.vue?vue&type=template&id=3803d630&scoped=true"
import script from "./outplace.vue?vue&type=script&lang=js"
export * from "./outplace.vue?vue&type=script&lang=js"
import style0 from "./outplace.vue?vue&type=style&index=0&id=3803d630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3803d630",
  null
  
)

export default component.exports